import * as Yup from "yup";

export  const loginValidationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

  export  const categoryValidationSchema = Yup.object({
    name: Yup.string().trim()
      .required("Name is required").max(50, "Name must be less than 50 characters"),
    // description: Yup.string()
    //   .required("Description is required").max(250, "Description must be less than 250 characters"),
  });


  export const fileUploadDocumentsValidationSchema=Yup.object({
    files: Yup.array()
    .min(1, "File is required") // Ensures at least one file is selected
    .test("non-empty", "File is required", (value) => Array.isArray(value) && value.length > 0),
  
  })


  export const uploadDocumentsValidationSchema = Yup.object({
    projectName: Yup.string()
    .when("isRelatedToProject", {
      is: true,
      then: (schema) => schema.required("Project Name is required").min(3, "Project Name must be at least 3 characters")
      .max(50, "Project Name must be less than 50 characters"),
      otherwise: (schema) => schema.notRequired(),
    }),

    files: Yup.array()
    .min(1, "File is required") // Ensures at least one file is selected
    .test("non-empty", "File is required", (value) => Array.isArray(value) && value.length > 0),
  
  


  title: Yup.string()
    .when("isRelatedToProject", {
      is: false,
      then: (schema) => schema.required("Title is required").min(3, "Title must be at least 3 characters")
      .max(50, "Title must be less than 50 characters"),
      otherwise: (schema) => schema.notRequired(),
    }),
    description: Yup.string()
    .max(250, "Description must be less than 250 characters"),
    tags: Yup.array()
  .min(1, "Please select at least one tag")
  .required("Tags are required"),
  otherTags: Yup.array()
  .min(1, "Please select at least one tag")
  .required("Tags are required")
  .test("unique-tags", "Duplicate tags are not allowed", (value) => {
    if (!value) return false; // Ensure value exists
    const tagValues = value.map((tag) => tag.value?.toLowerCase().trim()); // Normalize values
    return new Set(tagValues).size === tagValues.length; // Check uniqueness
  }),


    documentType: Yup.object()
    .required("Please select a tag") // Ensures an object is selected
    .typeError("Please select a valid tag"),
    isRelatedToProject: Yup.boolean()
    .required('Required Field')
    .oneOf([true, false], 'Please select either Yes or No'),
  });


  export const editModalValidationSchema =Yup.object({
    name: Yup.string()
    .required("Name is required").max(50, "Name must be less than 50 characters"),
  })